export default {
    routerName: '公告管理',
    announce: {
        searchName: '検索条件',
        name: '公告名',
        thumb: 'サムネイル',
        image: '画像',
        description: '記述',
        startTime: '開始日付',
        endTime: '終了日付',
        level: 'レベル',
        level0: '普通',
        level1: '正常',
        level2: '重要',
        scope: '範囲',
        scope0: 'フォアグラウンド',
        scope1: 'バックグラウンド',
        scope2: '両方',
        status: '状態',
        open: '有効',
        close: '無効',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
        releaseDateStartTime: '配布開始日付',
        releaseDateEndTime: '配布終了日付',
    },
    table: {
        id: 'ID',
        thumb: 'サムネイル',
        image: '画像',
        name: '公告名',
        startTime: '開始日付',
        endTime: '終了日付',
        level: 'レベル',
        scope: '範囲',
        status: '状態',
        createBy: '作成者',
        createTime: '作成日付',
    },
};
